export default "__VITE_ASSET__jfjDQAub__"